import { Moment } from "moment";

export interface Appointment {
  id: number;
  name: string;
  time: Moment;
  status: AppointmentStatus;
}

export enum AppointmentStatus {
  scheduled = "Scheduled",
  confirmation_request_sent = "Confirmation Request Sent",
  unconfirmed = "Unconfirmed",
  confirmed = "Confirmed",
  arrival_response_sent = "Arrival Response Sent",
  late = "Running Late",
  cancelled = "Cancelled",
  waiting = "Patient Waiting",
  entrance_request = "Patient Entrance Request Sent",
  in_treatment = "In Treatment",
  complete = "Complete",
  paperwork = "Waiting - Paperwork",
  late_response = "Running Late Resonse",
  cancelled_response = "CancelledResonse"
}
